import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { IoMdTrash, IoMdCreate } from 'react-icons/io';

import ActionButton from '../helpers/ActionButton';

const SignatureDisplay = ({
  check,
  string,
  setUnmountSetup,
  unmountSetup,
  updateProfile,
  setProfile,
  setSession,
  setUnexpectedError
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <div className="mt-10">
      <div className="mb-6">
        <h4 className="font-bold text-xl">Signature</h4>
        <p className="text-sm">
          This signature will be used in all legal documents, between you and complete farmer
          limited. You can change/update it, at any point in time.
        </p>
      </div>

      <div className="float-right flex flex-wrap">
        <ActionButton
          isSubmitting={isSubmitting}
          btnPad="p-2"
          color="bg-red-200"
          textColor="text-red-600"
          name="Remove"
          icon={<IoMdTrash size={15} />}
          click={async () => {
            try {
              setIsSubmitting(true);
              const response = await updateProfile({ signature: {} });
              setIsSubmitting(false);
              if (response.code === 200) {
                setProfile(response.data);
                toast.success(response.message, {
                  position: toast.POSITION.TOP_RIGHT
                });
              } else {
                toast.error(response.data.message, {
                  position: toast.POSITION.TOP_RIGHT
                });
              }
            } catch (error) {
              if (error && error.status === 401) setSession(false);
              else setUnexpectedError('Unexpected Server Error!');
            }
          }}
        />
        <ActionButton
          btnPad="p-2"
          color="bg-cf-300"
          name="Change"
          textColor="text-white"
          icon={<IoMdCreate size={15} />}
          click={() => setUnmountSetup(!unmountSetup)}
          className="ml-3"
        />
      </div>

      <div className="flex flex-warp justify-between relative bg-white w-full px-4 py-4 rounded">
        <div className="signature p-5">
          {check === 'image' ? (
            <img
              src={string}
              alt="signature"
              style={{ width: '150px', height: '80px', padding: '10px' }}
            />
          ) : (
            <span style={{ marginTop: '50px' }}>{string}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default SignatureDisplay;
